import { render, staticRenderFns } from "./DictationWordInput.vue?vue&type=template&id=6082c66f&"
import script from "./DictationWordInput.vue?vue&type=script&lang=js&"
export * from "./DictationWordInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports